import React, { useEffect, useRef, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";

import { closed } from "../../components/drawer/drawerSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import { clearLeadSourceDetails } from "./leadsourceSlice";
import {
  createLeadSource,
  getAllActiveLeadSource,
  getAllLeadSource,
  getLeadSourceByID,
  updateLeadSource,
} from "./services/leadsource.service";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import IconButton from "../../components/common/IconButton";

const CreateLeadSource: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const LeadSourceDetail = useAppSelector(
    (state) => state.leadsource.LeadSourceDetail,
  );
  const LeadSourceID = useAppSelector((state) => state.drawer.data);
  const formLoading = useAppSelector((state) => state.leadsource.formLoading);
  const isIndirect = useAppSelector((state) => state.drawer.isIndirect);
  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    return () => {
      dispatch(clearLeadSourceDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (LeadSourceID) {
      dispatch(getLeadSourceByID(LeadSourceID));
    }
  }, [LeadSourceID]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [LeadSourceDetail]);

  const handleSubmit = async (values: any) => {
    try {
      if (!LeadSourceID) {
        const insertPayload = {
          Source: values.Source,
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(createLeadSource(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearLeadSourceDetails());
          if (isIndirect) {
            dispatch(getAllActiveLeadSource());
          } else {
            dispatch(getAllLeadSource());
          }
        }
      } else {
        const editPayload = {
          ID: LeadSourceID,
          Source: values.Source,
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(updateLeadSource(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearLeadSourceDetails());
          dispatch(getAllLeadSource());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  return (
    <>
      {formLoading && <LoadingPanel gridRef={gridRef} />}
      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={LeadSourceDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement style={{ width: "100%" }}>
            <GridLayout
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
              gap={{ rows: 10 }}
              cols={[{ width: "100%" }]}
            >
              <GridLayoutItem className="mui-drawer-header">
                <Typography.h4 className="m-0">
                  {LeadSourceID ? "Update Lead Source" : "Add Lead Source"}
                </Typography.h4>
                <IconButton
                  type="button"
                  fillMode={"flat"}
                  themeColor={"dark"}
                  style={{ marginRight: 4 }}
                  onClick={() => dispatch(closed())}
                  icon={RxCross1}
                />
              </GridLayoutItem>
              <GridLayoutItem style={{ width: "100%" }}>
                <Field
                  name="Source"
                  label="Source"
                  placeholder="i.e. Source"
                  component={FormTextField}
                  validator={requiredValidator}
                  astrike={true}
                />
              </GridLayoutItem>

              <GridLayoutItem style={{ width: "100%" }}>
                <Field
                  name="IsActive"
                  label="Status"
                  astrike={true}
                  validator={requiredValidator}
                  placeholder="i.e. Active"
                  component={FormSelectionField}
                  options={STATUSARRAY?.map((status: any) => {
                    return {
                      value: status?.value,
                      label: status?.label,
                    };
                  })}
                />
              </GridLayoutItem>

              <GridLayoutItem
                colSpan={3}
                style={{
                  textAlign: "end",
                  marginTop: 20,
                  width: "100%",
                }}
              >
                <ButtonWithLoading
                  label={LeadSourceID ? "Update" : "Save"}
                  type="submit"
                  disabled={!formRenderProps.allowSubmit || formLoading}
                  loading={formLoading}
                />
                <Button
                  type="button"
                  fillMode={"outline"}
                  themeColor={"primary"}
                  style={{ marginLeft: 10 }}
                  onClick={handleFormClose}
                >
                  Cancel
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateLeadSource;
